import { render, staticRenderFns } from "./OfficialExams.vue?vue&type=template&id=20989f9e"
import script from "./OfficialExams.vue?vue&type=script&lang=js"
export * from "./OfficialExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20989f9e')) {
      api.createRecord('20989f9e', component.options)
    } else {
      api.reload('20989f9e', component.options)
    }
    module.hot.accept("./OfficialExams.vue?vue&type=template&id=20989f9e", function () {
      api.rerender('20989f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/official_exam/OfficialExams.vue"
export default component.exports